import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectedTicketsTableComponent } from './selected-tickets-table.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [SelectedTicketsTableComponent],
  imports: [
    CommonModule,
    FGBSharedModule
  ],
  exports: [SelectedTicketsTableComponent],
})
export class SelectedTicketsTableModule {}
